module.exports = __webpack_public_path__ + "static/blue-719cc0d2976181af83e8a3e47fafdc85.svg";